import { createI18n } from "vue-i18n";
import zhCN from "./zh-CN";
import enUS from "./en-US";

const i18n = createI18n({
  legacy: false, // Composition API 模式
  globalInjection: true, // 模板中可直接用 $t / $tm
  locale: "zh-CN",
  fallbackLocale: "zh-CN", // en 缺失键回退中文
  messages: {
    "zh-CN": zhCN,
    "en-US": enUS,
  },
});

export default i18n;
